import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useI18n } from '@/i18n';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

/**
 * A Link component that automatically prepends the current language prefix to the path.
 * Use this for all internal navigation links.
 */
export const LocalizedLink: React.FC<LocalizedLinkProps> = ({ to, children, ...props }) => {
  const { getLocalizedPath } = useI18n();
  
  // Don't modify external links or hash links
  if (to.startsWith('http') || to.startsWith('#') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    return <Link to={to} {...props}>{children}</Link>;
  }
  
  const localizedPath = getLocalizedPath(to);
  
  return <Link to={localizedPath} {...props}>{children}</Link>;
};

export default LocalizedLink;
